// extracted by mini-css-extract-plugin
export var container = "_6w-0";
export var error = "_6w-9";
export var label = "_6w-5";
export var light = "_6w-6";
export var md = "_6w-3";
export var sm = "_6w-2";
export var thin = "_6w-8";
export var thinBold = "_6w-7";
export var vertical = "_6w-4";
export var xs = "_6w-1";